import { currentPageName, bannerSuppressedPages } from '../functions/utils';
import Cookies from 'js-cookie';

export default class Banner {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.currentPage = currentPageName();
        this.suppressBannerPages = bannerSuppressedPages();
        this.BANNER_COOKIE_NAME = "dismissedIsaBanner";
        this.BANNER_COOKIE_EXPIRATION = 90; //days
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        this.close = this.passedElement.querySelector('#closeTransferBanner');
        const dismissedTransferBanner = Cookies.get(this.BANNER_COOKIE_NAME);

        if (!dismissedTransferBanner && !this.suppressBannerPages.includes(this.currentPage)) {
            document.body.classList.add("banner--open");
            this.passedElement.classList.remove("banner-closed");
        }
    }

    addEventListeners = () => {
        this.close.addEventListener('click', () => {
            document.body.classList.remove("banner--open");
            this.passedElement.classList.add("banner-closed");
            Cookies.set(this.BANNER_COOKIE_NAME, "true", {
                expires: this.BANNER_COOKIE_EXPIRATION,
                domain: '.tillitinvest.com'
            });
        });
    }

}